"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "21px",
    height: "36px",
    viewBox: "0 0 21 36"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M0,2 C0,0.896 0.902,0 1.995,0 L19.005,0 C20.107,0 21,0.89 21,2 L21,34.001 C21,35.105 20.098,36 19.005,36 L1.995,36 C0.893,36 0,35.11 0,34.001 L0,2 Z M3,30 L18,30 L18,3 L3,3 L3,30 Z M8,32.791 C8,32.354 8.36,32 8.803,32 L12.197,32 C12.64,32 13,32.349 13,32.791 L13,33.21 C13,33.646 12.64,34 12.197,34 L8.803,34 C8.36,34 8,33.652 8,33.21 L8,32.791 Z"
  }));
};

exports["default"] = _default;